import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, computed, inject, model, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppstateService } from 'src/app/services/appstate.service';
import { DataService } from 'src/app/services/data.service';
import { DialogService } from 'src/app/services/dialog.service';
import { UserService } from 'src/app/services/user.service';
import { Budgetantrag } from 'src/app/types/Budgetantrag';
import { IBudgetantrag } from 'src/app/types/IBudgetantrag';
import { IWirtschaftsplan } from 'src/app/types/IWirtschaftsplan';
import { IBudgetantragViewmodel } from 'src/app/types/viewmodels/budgetantrag.viewmodel';
import { IBudgetantragDialogData } from 'src/app/types/IBudgetantragDialogData';
import { BudgetDetailsService } from 'src/app/services/budget-details.service';


@Component({
  selector: 'app-budget-neu',
  // standalone: true,
  // imports: [],
  templateUrl: './budget-neu.component.html',
  styleUrl: './budget-neu.component.css'
})
export class BudgetNeuComponent {

  public contentHeight = computed(() => (this.budgetService.isBauControlling() ? '724px' : '406px'));
  public submitInProgress = signal<boolean>(false);

  
  public readonly dialogRef = inject(MatDialogRef<BudgetNeuComponent>);
  public readonly dialogData = inject<IBudgetantragDialogData>(MAT_DIALOG_DATA);

  constructor(private dataService: DataService,
    private userService: UserService,
    private appStateService: AppstateService,
    private dialogService: DialogService,
     public budgetService: BudgetDetailsService) {
  }

  ngOnInit(): void {

    // set DialogData
    //this.budgetService.isBauControlling.set(this.dialogData.isBauControlling ?? true);

    this.dataService.readBudgetantragNewDefaults(this.appStateService.projektId()!).subscribe({
      next: (data: HttpResponse<IBudgetantragViewmodel>) => {
        this.budgetService.antrag.set(data.body?.budgetantrag!);
        this.budgetService.wirtschaftsplaene.set(data.body?.wirtschaftsplaene!);
        if (this.budgetService.antrag().lageplanDateiname) {
          this.dataService.readBudgetantragNewDefaultLageplan(this.appStateService.projektId()!).subscribe({
            next: (data) => {
              this.budgetService.antragLageplan.set(data);
            },
            error: (err: HttpErrorResponse) => {
              if (this.userService.userInfo()!.isTestMode) {
                this.budgetService.antrag().lageplanDateiname = "";
              } else {
                this.dialogService.showInfoDialog("Der Lageplan konnte nicht geladen werden, obwohl ein Dateipfad angegeben ist. Bitte wenden Sie sich an die Administration des BAT's.", "Lageplan konnte nicht geladen werden", 280);
              }
              // handle 400er
            }
          });
        }
      },
      error: (err: HttpErrorResponse) => {
        // handle 400er
      }
    });
  }


  onCloseButtonClick(): void {
    this.dialogRef.close();
  }

  onSaveButtonClick(): void {
    if (!this.budgetService.ValidateBeforeSave()) {
      return;
    }

    this.submitInProgress.set(true);
    this.dataService.createBudgetantrag(this.appStateService.projektId()!, this.budgetService.antrag()).subscribe({
      next: (dataBudgetantrag: HttpResponse<Budgetantrag>) => {
        // refresh
        this.budgetService.antrag.set(dataBudgetantrag.body!);

        if (this.budgetService.antragLageplanChanged() && this.budgetService.antragLageplan()) {
          const formData = new FormData();
          formData.append("file", this.budgetService.antragLageplan()!, this.budgetService.antrag().lageplanDateiname);
          this.dataService.updateBudgetantragLageplan(dataBudgetantrag.body?.budgetantragID!, formData).subscribe({
            next: (data) => {
		      dataBudgetantrag.body!.lageplanDateiname = data;
              this.dialogRef.close(dataBudgetantrag.body);
            },
            error: (err: HttpErrorResponse) => {
              this.dialogService.showInfoDialog(err.error, 'Fehler beim Speichern des Lageplans', 280);
            }
          });
        } else {
          this.dialogRef.close(dataBudgetantrag.body);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.submitInProgress.set(false);
        this.dialogService.showInfoDialog(err.error, 'Fehler beim Speichern des Budgetantrages', 280);
      }

    });
  }

}
